import React from 'react';
import { Box, Container, Typography, Link, IconButton, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      sx={{
        background: 'linear-gradient(180deg, rgba(5, 8, 16, 0.95) 0%, rgba(34, 225, 101, 0.1) 100%)',
        color: 'white',
        py: 2,
        mt: 'auto',
        borderTop: '1px solid rgba(34, 225, 101, 0.2)',
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '1px',
          background: 'linear-gradient(90deg, transparent, rgba(34, 225, 101, 0.5), transparent)',
        }
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#22e165',
                fontWeight: 'bold',
                letterSpacing: '0.5px',
                background: 'linear-gradient(90deg, #22e165, #1a8f3d)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: '1.1rem',
              }}
            >
              Francisco Aguirre
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                letterSpacing: '0.5px',
                textAlign: 'center',
                display: 'block',
              }}
            >
              Computer Engineer
            </Typography>
          </Box>

          <Divider 
            sx={{ 
              width: '100%', 
              maxWidth: '150px',
              borderColor: 'rgba(34, 225, 101, 0.2)',
              my: 0.5,
            }} 
          />
          
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              mb: 1,
            }}
          >
            <IconButton
              component={Link}
              href="https://github.com/yourusername"
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                '&:hover': {
                  color: '#22e165',
                  transform: 'translateY(-2px)',
                  transition: 'all 0.3s ease',
                },
              }}
            >
              <GitHubIcon fontSize="small" />
            </IconButton>
            <IconButton
              component={Link}
              href="https://linkedin.com/in/fco-aguirred"
              target="_blank"
              rel="noopener noreferrer"
              size="small"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                '&:hover': {
                  color: '#22e165',
                  transform: 'translateY(-2px)',
                  transition: 'all 0.3s ease',
                },
              }}
            >
              <LinkedInIcon fontSize="small" />
            </IconButton>
            <IconButton
              component={Link}
              href="mailto:fj.aduery@gmail.com"
              size="small"
              sx={{
                color: 'rgba(255, 255, 255, 0.7)',
                '&:hover': {
                  color: '#22e165',
                  transform: 'translateY(-2px)',
                  transition: 'all 0.3s ease',
                },
              }}
            >
              <EmailIcon fontSize="small" />
            </IconButton>
          </Box>

          <Typography
            variant="caption"
            sx={{
              color: 'rgba(255, 255, 255, 0.7)',
              textAlign: 'center',
              maxWidth: '400px',
              lineHeight: 1.4,
            }}
          >
            {t('copyright')}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
